import React, { Fragment } from "react";
import "./Security.css";
import Hand from "../../assets/Home/hand.svg";
import Fade from "react-reveal/Fade";
import { Dimensions } from '../../Helper/sitedimension';
import { Link } from "react-router-dom";

const security = () => {
  const { width } = Dimensions.useWindowDimensions();
  return (
    <Fragment>
      {width > 500 ?
        <div className="container-fluid security">
          <div className="row">
            <div className="col-6">
              <Fade delay={1000}>
                <img className="hands" src={Hand} alt="hand" />
              </Fade>
            </div>
            <div className="col-6 main-content">
              <h4 className="main">
                <Fade delay={300}>
                  Swiper NO Swiping!
            </Fade>
              </h4>
              <p className="content">
                <Fade delay={600}>
                  With the rising incidents of cyber crimes, security has become a major concern among enterprises across
                   different industrial sectors. At least 2000 unique vulnerabilities have been reported within the span
                    of this year itself. To tackle such instances and figure out the potential vulnerabilities at the
                    organization level, we have come up with Secure Blink - an AI based cyber security solution which
                    helps in scanning, predicting, and reporting the major issues in the systems. AI is the future
                    of cyber security and we are working towards building the best solution out of it.
  
            </Fade>
              </p>
              <Fade delay={800}>
                <Link to='/about'>
                  <button type="button" className="btn btn-outline-white" id="butt">
                    <span className="btn-content">Know More</span>
                  </button>
                </Link>
              </Fade>
            </div>
          </div>
        </div>
        :
        <div className="securityhome">
          <div className="row">
            <div className="col-12 main-contenthome">
              <h4 className="mainhome">
                <Fade delay={300}>
                  Swiper NO Swiping!
          </Fade>
              </h4>
              <p className="contenthome">
                <Fade delay={600}>
                  With the rising incidents of cyber crimes, security has become a major concern among enterprises across different industrial sectors.
                  At least 2000 unique vulnerabilities have been reported within the span of this year itself. To tackle such instances and figure out
                   the potential vulnerabilities at the organization level, we have come up with Secure Blink - an AI based cyber security solution
                   which helps in scanning, predicting, and reporting the major issues in the systems.
                   AI is the future of cyber security and we are working towards building the best solution out of it.
  
          </Fade>
              </p>
              <Fade delay={800}>
                <Link to='/about'>
                  <button type="button" className="btn btn-outline-white butthome" id="butt">
                    <span className="btn-content">Know More</span>
                  </button>
                </Link>
              </Fade>
            </div>
          </div>
        </div>
      }
    </Fragment>
  );
};

export default security;
